import { Badge, DataGrid, TooltipV2 } from '@cimplico/components';
import { Link } from 'react-router-dom';
import { useFirmContext } from '../../providers/FirmProvider';
import { ProcedureTemplateOverview } from '../../types/procedure';
import { formatDateTime, calcRelativeTime } from '../../utilities/formatting';

type ProcedureTemplateRowProps = {
    id: string;
    procedureTemplate: ProcedureTemplateOverview;
};

function ProcedureTemplateRow({ id, procedureTemplate }: ProcedureTemplateRowProps): JSX.Element {
    const { shortId } = useFirmContext();

    return (
        <DataGrid.Row id={id}>
            <div className="flex items-center gap-4 py-2">
                <Link to={`/${shortId}/templates/procedures/${procedureTemplate.id}`}>
                    <p className="font-medium text-indigo-600 dark:text-indigo-400 text-sm cursor-pointer">{procedureTemplate.name}</p>
                </Link>
                <div className="flex items-center gap-1">
                    {procedureTemplate.system && <Badge color="blue" label="System" shape="squared" size="small" variant="default" />}
                    {procedureTemplate.default && <Badge color="gray" label="Default" shape="squared" size="small" variant="default" />}
                </div>
            </div>
            <p className="text-sm text-gray-700">{procedureTemplate.procedures}</p>
            <p className="text-sm text-gray-700">
                {procedureTemplate.createdBy ? `${procedureTemplate.createdBy.firstName} ${procedureTemplate.createdBy.lastName}` : '-'}
            </p>
            <TooltipV2 message={formatDateTime(procedureTemplate.updatedAt)}>
                <p className="text-gray-700 text-sm">{calcRelativeTime(procedureTemplate.updatedAt)}</p>
            </TooltipV2>
        </DataGrid.Row>
    );
}
export default ProcedureTemplateRow;
